const STORAGE_KEY = 'wortelogy-station-filter'
export const STATION_FILTER_CHANGED_EVENT = 'wortelogy-station-filter-changed'

export function getStationFilter(): string {
  if (typeof sessionStorage === 'undefined') return ''
  try {
    return sessionStorage.getItem(STORAGE_KEY)?.trim() ?? ''
  } catch {
    return ''
  }
}

export function setStationFilter(station: string): void {
  if (typeof sessionStorage === 'undefined') return
  try {
    const trimmed = station.trim()
    if (trimmed) {
      sessionStorage.setItem(STORAGE_KEY, trimmed)
    } else {
      sessionStorage.removeItem(STORAGE_KEY)
    }
    window.dispatchEvent(new CustomEvent(STATION_FILTER_CHANGED_EVENT))
  } catch {
    // ignore quota / private mode
  }
}
